// Pricing FAQ shown first on each treatment page (and first in its FAQPage schema).
const SUFFIX =
  " No insurance or membership fee needed. A prescription is required and is issued only if a licensed clinician determines treatment is appropriate.";

const faq = (q, a) => ({ q, a: a + SUFFIX });

export const PRICE_FAQS = {
  "weight-loss": faq(
    "How much does compounded semaglutide or tirzepatide cost?",
    "Compounded semaglutide is $159/month on a 3-month plan or $199 month to month. Compounded tirzepatide is $219/month on a 3-month plan or $259 month to month. Pricing is flat across available doses."
  ),
  vitality: faq(
    "How much does NAD+ cost?",
    "NAD+ injection is $159/month on a 3-month plan or $199 month to month. NAD+ nasal spray is $159/month."
  ),
  antioxidant: faq(
    "How much does glutathione cost?",
    "Glutathione injection is $99/month on a 3-month plan or $129 month to month. Glutathione nasal spray is $129/month."
  ),
  recovery: faq(
    "How much does sermorelin cost?",
    "Sermorelin is $165/month on a 3-month plan or $210 month to month."
  ),
  "metabolic-support": faq(
    "How much does MIC + B12 cost?",
    "MIC + B12 is $103/month on a 3-month plan or $129 month to month."
  ),
  energy: faq("How much does B12 cost?", "B12 injections are $119/month."),
  "skin-care": faq("How much does GHK-Cu face cream cost?", "GHK-Cu face cream is $179/month."),
};
